<h2 mat-dialog-title>{{ data.file.name }}</h2>

<mat-dialog-content>
  <div *ngIf="isPdf(data.file.name)">
    <iframe [src]="data.url | safeUrl" width="100%" height="500px"></iframe>
  </div>

  <div *ngIf="isImage(data.file.name)">
    <img [src]="data.url" alt="Preview" style="max-width: 100%; max-height: 500px;" />
  </div>

  <div *ngIf="isText(data.file.name)">
    <iframe [src]="data.url | safeUrl" width="100%" height="400px"></iframe>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <a [href]="data.url" download>
    <button mat-button color="primary">Download</button>
  </a>
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
